import { t } from '@lingui/macro';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { onChangeOaCompetitorsFilter } from '../../../ac/onChangeMapFilters';
import { startsCompetitorsFilterValues } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { DynamicOperatorsLegend } from '../DynamicOperatorsLegend';
import { StandardRadioGroup } from '../StandardRadioGroup';
import styles from '../FilterSidebar.module.css';

const OaCompetitorsFilterComponent = ({
    onChangeOaCompetitorsFilter,
    oaCompetitorsDays,
    oaCompetitorsAvailableOperators,
}) => (
    <div>
        <div className={styles.legHead}>{t`Лидер стартов:`}</div>
        <DynamicOperatorsLegend
            availableOperators={oaCompetitorsAvailableOperators}
            extraItems={[{
                id: 'red',
                label: { id: 'label_no_starts', message: t`Нет стартов в этот период` },
                color: 'red',
            }]}
        />
        <div className={styles.legHead}>{t`Период:`}</div>
        <StandardRadioGroup
            value={String(oaCompetitorsDays)}
            onChange={onChangeOaCompetitorsFilter}
        >
            {
                startsCompetitorsFilterValues.map(value => (
                    <FormControlLabel
                        key={value}
                        className={styles.isochroneFilterLabel}
                        control={
                            <Radio
                                checked={oaCompetitorsDays === value}
                                onChange={onChangeOaCompetitorsFilter}
                                value={value}
                                className={classnames(
                                    styles.isochroneFilterInput, {
                                        [styles.checkedIsochroneFilterInput]: oaCompetitorsDays === value,
                                    }
                                )}
                                size='small'
                            />
                        }
                        label={value === 1 ? t`${value} день` : t`${value} дней`}
                        labelPlacement='end'
                    />
                ))
            }
        </StandardRadioGroup>
    </div>
);
const mapStateToProps = ({ mapFilters: { oaCompetitorsDays, oaCompetitorsAvailableOperators } }) => ({
    oaCompetitorsDays,
    oaCompetitorsAvailableOperators,
});
const ConnectedComponent = connect(mapStateToProps, { onChangeOaCompetitorsFilter })(OaCompetitorsFilterComponent);

export const OaCompetitorsFilter = withDisplayedLayersCheck(ConnectedComponent, 'Операционные зоны (конкуренты)');

